// All game times shown in California (Pacific) time.
const TZ = 'America/Los_Angeles';

export const fmtPT = (iso, withDay = true) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.toLocaleString('en-US', { timeZone: TZ, ...(withDay ? { weekday: 'short' } : {}), hour: 'numeric', minute: '2-digit' })} PT`;
};

// Rewrites "7:30 PM EDT" / "7:30PM ET" / "6:00 PM CT" inside any text as Pacific time.
const OFFSET = { E: 3, C: 2, M: 1, P: 0 };
export const ptText = (s) => String(s || '').replace(/(\d{1,2}):(\d{2})\s*([AP])\.?M\.?\s*(E|C|M|P)(?:S|D)?T\b/gi, (_, h, m, ap, z) => {
  let hr = (Number(h) % 12) + (ap.toUpperCase() === 'P' ? 12 : 0) - OFFSET[z.toUpperCase()];
  hr = (hr + 24) % 24;
  return `${hr % 12 || 12}:${m} ${hr >= 12 ? 'PM' : 'AM'} PT`;
});

// Start time for a ticket leg: ESPN's real start time if matched, else the ticket's own text converted.
export const legTimePT = (leg) => (leg.event_date ? fmtPT(leg.event_date) : ptText(leg.game_time));
